const ICONS = {
  notice: `<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>`,
  alert:  `<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/></svg>`,
  error:  `<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/></svg>`,
  default: `<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>`
}

const BORDER_CLASSES = {
  notice:  "border-l-green-500",
  alert:   "border-l-red-500",
  error:   "border-l-red-500",
  default: "border-l-blue-500",
}

const TEXT_CLASSES = {
  notice:  "text-green-500",
  alert:   "text-red-500",
  error:   "text-red-500",
  default: "text-blue-500",
}

export function showToast(message, type = "notice") {
  const container = document.getElementById("toast-container")
  if (!container) return

  const borderClass = BORDER_CLASSES[type] ?? BORDER_CLASSES.default
  const textClass   = TEXT_CLASSES[type]   ?? TEXT_CLASSES.default
  const icon        = ICONS[type]          ?? ICONS.default

  const item = document.createElement("div")
  item.className = `toast-item translate-x-full opacity-0 ${borderClass}`
  item.setAttribute("role", "alert")
  item.setAttribute("data-controller", "flash-message")
  
  item.innerHTML = `
    <div class="flex-shrink-0 mt-0.5 ${textClass}">${icon}</div>
    <p class="flex-1 text-btn text-graphite-800"></p>
    <button type="button" class="flex-shrink-0 text-gray-400 hover:text-gray-600 rounded-control focus:outline-none transition-colors" aria-label="Close" data-action="click->flash-message#dismiss">
      <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
      </svg>
    </button>
  `
  
  item.querySelector("p").textContent = message

  container.appendChild(item)
}
